<template>
  <div>
    <div class="q-mt-md">
      <div class="row-reverse">
        <q-btn
          color="primary"
          label="Add Mileage"
          @click="onAdd"
          class="q-mb-md q-ml-lg"
        />
      </div>
    </div>
    <BaseTable
      :rows="formattedMiles"
      :columns="columns"
      :total-rows="totalMiles"
      :get-edit-url="getEditUrl"
    />
  </div>
</template>

<script>
import BaseTable from '@/components/BaseTable';
import axios from 'axios';

export default {
  name: 'MileTable',
  components: {
    BaseTable
  },
  data() {
    return {
      miles: [],
      totalMiles: 0,
      columns: [
        { name: 'id', align: 'left', label: 'ID', field: 'id', sortable: true },
        { name: 'customer_name', align: 'left', label: 'Customer', field: 'customer_name', sortable: true },
        { name: 'producer_name', align: 'left', label: 'Producer', field: 'producer_name', sortable: true },
        { name: 'field_name', align: 'left', label: 'Field', field: 'field_name', sortable: true },
        { name: 'miles', align: 'right', label: 'Miles', field: 'miles', sortable: true },
        { name: 'add_date', align: 'left', label: 'Add Date', field: 'add_date', sortable: true },
        { name: 'edit_date', align: 'left', label: 'Edit Date', field: 'edit_date', sortable: true },
        { name: 'actions', align: 'center', label: 'Actions', field: 'actions', sortable: false }
      ]
    };
  },
  computed: {
    formattedMiles() {
      return this.miles.map(mile => ({
        ...mile,
        customer_name: mile.customer_id.name, // Assuming the API returns nested customer object with `name`
        producer_name: mile.producer_id.name, // Assuming the API returns nested producer object with `name`
        field_name: mile.field_id.name, // Assuming the API returns nested field object with `name`
        add_date: new Date(mile.add_date).toLocaleDateString(),
        edit_date: new Date(mile.edit_date).toLocaleDateString()
      }));
    }
  },
  created() {
    this.fetchMiles();
  },
  methods: {
    fetchMiles() {
      axios
        .get('/api/v1/mile/miles/')
        .then(response => {
          this.miles = response.data;
          this.totalMiles = response.data.length;
        })
        .catch(error => {
          console.error('Error fetching miles:', error);
        });
    },
    onAdd() {
      this.$router.push('/miles/add');
    },
    getEditUrl(row) {
      return `/miles/edit/${row.id}/`;
    }
  },
  watch: {
    miles() {
      this.$forceUpdate();
    }
  }
};
</script>

<style scoped>
/* Add any specific styles for the MileTable here */
</style>
